import { filter } from 'rxjs/operators';
import { EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
var AddressesComponent = /** @class */ (function () {
    function AddressesComponent() {
        var _this = this;
        this.addressesSelect = new FormControl();
        this.selectActive = false;
        this.addressChanged = new EventEmitter();
        this.addressesSelect.valueChanges.pipe(filter((function (address) { return (address && address.code) !== _this.current; }).bind(this)))
            .subscribe(this.selectedChanged.bind(this));
        this.myTranslationCode = "checkout.delivery-address";
    }
    AddressesComponent.prototype.ngOnChanges = function (changes) {
        var addresses = (changes.addresses && changes.addresses.currentValue) || this.addresses;
        // let current = (changes.current && changes.current.currentValue) || this.current
        // Only prefill the address if there's only one address available.
        if (addresses && addresses.length === 1) {
            this.addressesSelect.setValue(addresses[0]);
            this.selected = addresses[0];
        }
        // let defAddress = addresses && Array.isArray(addresses)
        //   ? addresses.find(a => (a && a.code) === current)
        //     || addresses.find(a => a.isPrimary)
        //     || addresses[0]
        //   : null
        // this.addressesSelect.setValue(defAddress)
        // this.selected = defAddress
    };
    Object.defineProperty(AddressesComponent.prototype, "hasMultiple", {
        get: function () {
            return this.addresses.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    AddressesComponent.prototype.toggleSelect = function () {
        this.selectActive = !this.selectActive;
    };
    AddressesComponent.prototype.selectedChanged = function (address) {
        this.selected = address;
        this.addressChanged.emit(address);
    };
    AddressesComponent.prototype.onAddressClick = function (address) {
        this.selected = address;
        this.addressChanged.emit(address);
        this.selectActive = false;
    };
    return AddressesComponent;
}());
export { AddressesComponent };
